import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'
import { REDUCER_NAME } from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const CHANGE_BAR_CODE = NS + 'CHANGE_BAR_CODE'



// WEBPACK FOOTER //
// ./src/modules/process/state/barcode/type.js